<template>
    <div class="hello">
        <h1>{{ $t('site.nav.contact') }}</h1>

        <P>
            {{ $t('site.contact1') }}
            <br>{{ $t('site.contact2') }}
        </P>

        <p> {{ $t('site.contact3') }}</p>

        <p>
            <i18n path="site.contact4" tag="span">
                <router-link to="/faq">{{$t('site.nav.faq')}}</router-link>
            </i18n>
        </p>

        <div class="row m-b-30">
            <div class="col-sm-12">
                <form method="POST" action="https://formspree.io/elvenstats@gmail.com">
                    <input type="hidden" name="_next" value="http://www.elvenstats.com/thanks/">
                    <input type="hidden" name="playerId" :value="viewAsPlayer && viewAsPlayer.playerId">
                    <input type="hidden" name="server" :value="viewAsPlayer && viewAsPlayer.server">
                    <input type="hidden" name="username" :value="viewAsPlayer && viewAsPlayer.username">
                    <input type="hidden" name="_format" value="plain" />
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="name" class="h6">{{ $t('site.name') }}</label>
                            <input type="text" id="name" name="name" class="form-control form-white" autocomplete='name'>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="email" class="h6">{{ $t('site.email') }}</label>
                            <input type="text" id="email" name="_replyto" class="form-control form-white" autocomplete='email'>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <label for="_subject" class="h6">{{ $t('site.subject') }}</label>
                            <input type="text" id="_subject" name="_subject" class="form-control form-white">
                        </div>
                    </div>
                    <label for="message" class="h6">{{ $t('site.message') }}</label>
                    <textarea rows="7" id="message" name="message" class="form-control form-white"></textarea>
                    <br/><small>{{ $t('site.ourNativeLanguage') }}</small><br/>

                    <input type="hidden" name="browserWidth" :value="width">
                    <input type="hidden" name="browserHeight" :value="height">
                    <input type="hidden" name="browser" :value="userAgent">


                    <button type="submit" class="btn btn-primary m-t-20" style="margin-left:-2px;">{{ $t('site.send') }}</button>
                </form>
            </div>
        </div>
        <br/>
        <mail-chimp-signup></mail-chimp-signup>
        <br/><br/>

    </div>
</template>

<script>
    import MailChimpSignup from "@/components/MailChimpSignup";

    export default {
        components: { MailChimpSignup },
        name: 'Contact',
        props: ['viewAsPlayer'],
        data () {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
                userAgent: navigator && navigator.userAgent,
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue